import React, { FC, ReactElement, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Button, List, ListItem, Typography } from "@material-ui/core";
import { useDispatch } from "react-redux";

import { useAuthenticationStyles } from "./AuthenticationStyles";
import { AppIcon, CommunityIcon, ReplyIcon, SearchIcon,  } from "../../icons";
import RegistrationModal from "./RegistrationModal/RegistrationModal";
import CustomizeModal from "./CustomizeModal/CustomizeModal";
import CreateAccountModal from "./CreateAccountModal/CreateAccountModal";
import EmailVerificationModal from "./EmailVerificationModal/EmailVerificationModal";
import SetPasswordModal from "./SetPasswordModal/SetPasswordModal";
import { ACCOUNT_LOGIN } from "../../constants/path-constants";
import { setOpenModal } from "../../store/ducks/authentication/actionCreators";
import { APP_NAME, USER_ID } from '../../constants/common-constants';
import VeracityModal from './VeracityModal/VeracityModal';

const Authentication: FC = (): ReactElement => {
    const classes = useAuthenticationStyles();
    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();

    const handleClickOpenSignIn = (): void => {
        localStorage.removeItem(USER_ID);
        history.push(ACCOUNT_LOGIN);
    };

    const handleClickOpenSignUp = (): void => {
        localStorage.removeItem(USER_ID);
        dispatch(setOpenModal());
    };
    
    useEffect(() => {
      if (location.state && location.state === 'signUp') {
        dispatch(setOpenModal());
        history.replace({ ...location, state: null });
      }
    }, [location, history, dispatch]);

    return (
        <div className={classes.wrapper}>
            <section className={classes.leftSide}>
                <AppIcon color="primary" className={classes.leftSideTwitterIcon} />
                {/* <div className={classes.leftSideTwitterIcon}><AppIcon color="primary" width={`100%`} height={`100%`} /></div> */}
                <List className={classes.leftSideListInfo}>
                    <ListItem>
                        <Typography variant="h6">
                            <>{SearchIcon}</>
                            Follow your interests.
                        </Typography>
                    </ListItem>
                    <ListItem>
                        <Typography variant="h6">
                            <>{CommunityIcon}</>
                            Hear what people are talking about.
                        </Typography>
                    </ListItem>
                    <ListItem>
                        <Typography variant="h6">
                            <ReplyIcon color='#fff'/>
                            Join the conversation.
                        </Typography>
                    </ListItem>
                </List>
            </section>
            <section className={classes.rightSide}>
                <div className={classes.rightSideWrapper}>
                    <AppIcon color="primary" className={classes.rightSideTwitterIcon} />
                    <Typography className={classes.rightSideTittle} variant="h4">
                        See what's happening in the world right now
                    </Typography>
                    <Typography>
                        <b>Join {APP_NAME} today!</b>
                    </Typography>
                    <br />
                    <Button
                        className={classes.button}
                        onClick={handleClickOpenSignUp}
                        variant="contained"
                        color="primary"
                        size="large"
                        fullWidth
                    >
                        Sign up
                    </Button>
                    <Button
                        className={classes.button}
                        onClick={handleClickOpenSignIn}
                        variant="outlined"
                        color="primary"
                        size="large"
                        fullWidth
                    >
                        Log in
                    </Button>
                    <RegistrationModal />
                    <CustomizeModal />
                    <CreateAccountModal />
                    <EmailVerificationModal />
                    <SetPasswordModal />
                    <VeracityModal />
                </div>
            </section>
        </div>
    );
};

export default Authentication;
